export const SUMMARY_BULLET_UTENSILS = "utensils";

/** @type {readonly string[]} */
export const SUMMARY_BULLET_START_DIGITS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];

export const SUMMARY_BULLET_VALUES = [
  SUMMARY_BULLET_UTENSILS,
  ...SUMMARY_BULLET_START_DIGITS,
];

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeSummaryBulletStyle(raw) {
  if (raw == null || raw === "") return SUMMARY_BULLET_UTENSILS;
  if (raw === SUMMARY_BULLET_UTENSILS) return SUMMARY_BULLET_UTENSILS;
  const s = String(raw);
  if (SUMMARY_BULLET_START_DIGITS.includes(s)) return s;
  return SUMMARY_BULLET_UTENSILS;
}
